import { COMPACT_STAGE_QUERY } from './use-compact-stage';

// A phone's short edge. This is a *device* threshold, not a layout one: it exists so
// PORTRAIT_LOCK_QUERY (use-orientation.ts) can tell a phone held upright from a tablet,
// which is why it stays at 768 even though no sidebar rule uses it any more. Widening
// it would start telling ~820px tablets to rotate, which that file explicitly avoids.
export const MOBILE_BREAKPOINT = 768;

/**
 * The width/height at which the sidebar stops being a permanent rail and becomes an
 * off-canvas drawer — the JS mirror of the media query in Layout.scss, TopHeader.scss
 * and SideBar.scss.
 *
 * Deliberately the same query as the roleplay stage's, aliased rather than restated so
 * the two cannot drift: a phone in landscape (844×390 — the orientation the roleplay
 * page asks for) has to be on the same side of both, or a permanent 260px rail sits
 * next to a stage that has already gone compact.
 *
 * Anything asking "is the sidebar a drawer right now?" belongs on this, NOT on
 * MOBILE_BREAKPOINT above — that constant used to serve both, and the two answers
 * diverged the moment the drawer moved off 768px.
 */
export const SIDEBAR_DRAWER_QUERY = COMPACT_STAGE_QUERY;
